import { FormInstance } from "antd";
import { RepairShopBusiness } from "../../../model/RepairShopBusiness";
import { RepairShopBusinessBreakTimes } from "../../../model/RepairShopBusinessBreakTimes";
import { RepairShopDayOffs } from "../../../model/RepairShopDayOffs";
import { RepairShopTemporaryChangedBusiness } from "../../../model/RepairShopTemporaryChangedBusiness";
import {
  DayOffDay,
  DayOffWeek,
  RoutineType,
  RestDayType,
  BusinessDayType,
  ReservationInterval,
} from "../../../shared/enums";

export interface ConfigFormValues {
  repairShopTemporaryBusinesses?: RepairShopTemporaryChangedBusiness[];

  repairShopBusiness?: NewRepairShopBusiness;

  businessDayTypes?: BusinessDayType;

  startTime?: moment.Moment;

  endTime?: moment.Moment;

  weekdayWeekendTimeArray?: ReservationTime[];

  alldayTimeArray?: ReservationTime[];

  alldayBreakTimeArray?: AllDayBreakTime[];

  hasRoutineRestDay?: boolean;

  routineDayOffType?: RoutineType;

  weeklyDayOffs?: RepairShopDayOffs[];

  notWeeklyDayOffs?: NotWeeklyDayOff[];

  isEveryDayRestSame?: BusinessDayType;

  isWorkAtHoliday?: boolean;

  everyDaySameRestTimeArray?: DayOffTime[];

  notEveryDaySameRestTimeArray?: RestTime[];

  holidayRestTimes?: RestTime;

  temporaryClosedReason?: string;

  temporaryCloseRanges?: moment.Moment[][];

  temporaryChangeArray?: RepairShopTemporaryChangedBusiness[];

  maximumCounts?: MaximumCount[];

  isDaySelectOn?: boolean;
}
export interface ReservationTime {
  startTime?: moment.Moment;

  endTime?: moment.Moment;

  days?: string[];
}
export interface NotWeeklyDayOff {
  dayOffWeek?: DayOffWeek;

  dayOffDays?: DayOffDay[];
}
export interface MaximumCount {
  days: DayOffDay[];
  maximumCounts: number[];
  isButton?: boolean;
  key?: string;
}
export interface DayOffTime {
  startTime?: moment.Moment;

  endTime?: moment.Moment;
}
export interface RestTime {
  day: RestDayType;

  times: DayOffTime[];
}
export interface NewRepairShopBusiness extends RepairShopBusiness {
  [index: string]: any;
}
export interface BusinessInfoOfDay {
  dayOffDay: DayOffDay;

  breakTimes: RepairShopBusinessBreakTimes[];

  startTime?: string | null;

  endTime?: string | null;

  reservationInterval: ReservationInterval;
}
export interface AllDayBreakTime {
  days: DayOffDay[];

  breakTimes: RepairShopBusinessBreakTimes[];
}
export interface MakeDisabledTimeArgs {
  disabledTimes?: DayOffTime[];
  mode?: TimeMode;
  fatestEndTime?: moment.Moment;
  fatestStartTime?: moment.Moment;
  latestEndTime?: moment.Moment;
  latestStartTime?: moment.Moment;
}
export interface CheckDuplicatedBreakTimeArgs {
  target: DayOffTime;
  times: DayOffTime[];
}

export enum TimeMode {
  END,
  START,
}
export interface FormError {
  errors: string[];
  name: string;
  index?: number;
  subComponentErrors?: FormError[];
}
export interface RenderInputProps {
  form: FormInstance;
  errors: FormError[];
}
